/* Progressive navigation only. No form, analytics or product-data mutations. */
(() => {
  function init(root = document) {
    root.querySelectorAll('main [style*="overflow-x: auto"], .article-template__content table').forEach(region => {
      if (region.scrollWidth > region.clientWidth + 1 && !region.hasAttribute('tabindex')) {
        region.setAttribute('tabindex', '0');
        region.setAttribute('role', 'region');
        region.setAttribute('aria-label', region.matches('table') || region.querySelector('table') ? 'Scrollable reference table' : 'Scrollable content');
      }
    });
    const article = root.querySelector('.article-template__content');
    if (article && !article.querySelector('.wika-v2-toc')) {
      const headings = [...article.querySelectorAll('h2')];
      if (headings.length > 2) {
        const toc = document.createElement('details');
        toc.className = 'wika-v2-toc';
        const summary = document.createElement('summary');
        summary.textContent = 'In this guide'; toc.append(summary);
        const nav = document.createElement('nav'); nav.setAttribute('aria-label', 'Article contents');
        headings.forEach((heading, i) => {
          if (!heading.id) heading.id = `wika-guide-${i + 1}`;
          const a = document.createElement('a'); a.href = `#${heading.id}`; a.textContent = heading.textContent; nav.append(a);
        });
        toc.append(nav); article.prepend(toc);
      }
    }
    const kids = root.querySelector('[data-ksc-page="custom"]');
    if (kids && !kids.querySelector('.wika-v2-section-nav')) {
      const nav = document.createElement('nav'); nav.className = 'wika-v2-section-nav'; nav.setAttribute('aria-label', 'Customization directions');
      kids.querySelectorAll('.ksc-capability-group').forEach((group, i) => {
        if (!group.id) group.id = `custom-direction-${i + 1}`;
        const a = document.createElement('a'); a.href = `#${group.id}`; a.textContent = group.querySelector('h2').textContent; nav.append(a);
      });
      kids.querySelector('#capabilities')?.prepend(nav);
      kids.querySelectorAll('.ksc-showcase img').forEach(img => {
        if (img.closest('a')) return;
        const a = document.createElement('a'); a.className = 'wika-v2-image-link'; a.href = img.src; a.target = '_blank'; a.rel = 'noopener';
        a.setAttribute('aria-label', `Open full image: ${img.closest('figure').dataset.kscShowcaseId}`);
        img.before(a); a.append(img);
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();


/* WIKA_P1_MOBILE_LEAD_BAR_BEHAVIOR */
(function () {
  function setupWikaMobileLeadBar() {
    var bar = document.querySelector('.wk-mobile-lead-bar');
    if (!bar) return;

    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var footer = document.querySelector('footer, .footer');
    var footerVisible = false;
    var ticking = false;

    function hasFormFocus() {
      var active = document.activeElement;
      return !!(active && active.matches && active.matches('input, textarea, select, button, [contenteditable="true"]'));
    }

    /* WIKA_RC_MOBILE_LEAD_BAR_FORM_AVOIDANCE_FIX */
    function formControlNearLeadBar() {
      if (!mobileQuery.matches) return false;

      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var barHeight = bar.offsetHeight || 0;
      var safeGap = 12;
      var exclusionTop = viewportHeight - barHeight - safeGap;
      var controls = document.querySelectorAll(
        'form input:not([type="hidden"]), form textarea, form select, form button, form [contenteditable="true"], form [data-wika-submit-status]'
      );

      for (var i = 0; i < controls.length; i += 1) {
        var control = controls[i];
        var rect = control.getBoundingClientRect();
        var style = window.getComputedStyle(control);
        var visibleControl =
          rect.width > 0 &&
          rect.height > 0 &&
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          style.opacity !== '0';

        if (!visibleControl) continue;

        if (rect.bottom > exclusionTop && rect.top < viewportHeight) {
          return true;
        }
      }

      return false;
    }

    function sync() {
      ticking = false;
      var threshold = Math.max(240, Math.round(window.innerHeight * 0.55));
      var visible =
        mobileQuery.matches &&
        window.scrollY > threshold &&
        !footerVisible &&
        !hasFormFocus() &&
        !formControlNearLeadBar();
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    function requestSync() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(sync);
    }

    if ('IntersectionObserver' in window && footer) {
      var observer = new IntersectionObserver(function (entries) {
        footerVisible = !!(entries[0] && entries[0].isIntersecting);
        requestSync();
      }, { threshold: 0.05 });
      observer.observe(footer);
    }

    window.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', requestSync, { passive: true });
    document.addEventListener('focusin', requestSync);
    document.addEventListener('focusout', function () {
      window.setTimeout(requestSync, 0);
    });

    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', requestSync);
    else if (mobileQuery.addListener) mobileQuery.addListener(requestSync);

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupWikaMobileLeadBar, { once: true });
  } else {
    setupWikaMobileLeadBar();
  }
})();


/* WIKA_P2_A002_PROJECT_SUPPORT_CTA */
(function () {
  function fixAboutProjectSupport(root) {
    var scope = root && root.querySelector ? root : document;
    var shell = scope.querySelector('.wika-page-shell--about-us') || document.querySelector('.wika-page-shell--about-us');
    if (!shell || shell.getAttribute('data-wika-project-support-fixed') === 'true') return;

    var headings = shell.querySelectorAll('h2');
    var heading = null;
    for (var i = 0; i < headings.length; i += 1) {
      if ((headings[i].textContent || '').trim() === 'Project Support') {
        heading = headings[i];
        break;
      }
    }
    if (!heading) return;

    var paragraph = heading.nextElementSibling;
    if (!paragraph || paragraph.tagName !== 'P') return;
    var link = paragraph.querySelector('a[href="/pages/contact"], a[href$="/pages/contact"]');
    if (!link) return;

    var label = (link.textContent || 'Contact WIKA Packing').trim();
    var textNode = document.createTextNode(label);
    link.parentNode.replaceChild(textNode, link);

    var cta = document.createElement('a');
    cta.href = '/pages/contact';
    cta.className = 'button wika-project-support-cta';
    cta.textContent = 'Contact WIKA Packing';
    cta.setAttribute('data-wika-quote-cta', 'true');
    cta.setAttribute('data-wika-cta-position', 'project_support');
    cta.setAttribute('data-wika-cta-label', 'Contact WIKA Packing');
    paragraph.insertAdjacentElement('afterend', cta);
    shell.setAttribute('data-wika-project-support-fixed', 'true');
  }

  function init(root) {
    fixAboutProjectSupport(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();


/* WIKA_P2_A014_RESPONSIVE_INFOGRAPHICS */
(function () {
  var replacements = {
    'geo16v1-manufacturer-project-flow.webp': {
      title: 'Custom glasses case project flow',
      type: 'flow',
      items: [
        ['1', 'Requirement', 'Case type, frame size, quantity, material and packing brief'],
        ['2', 'Structure review', 'Confirm fit, opening method and packaging direction'],
        ['3', 'Artwork setup', 'Confirm logo position, scale and color reference'],
        ['4', 'Sample', 'Review the real product before bulk production'],
        ['5', 'Approval', 'Freeze the approved sample and confirmed specification'],
        ['6', 'Bulk production', 'Produce against the approved reference'],
        ['7', 'QC & shipment', 'Check structure, branding, surface, lining and packing']
      ]
    },
    'geo16v1-sustainable-sampling-checklist.webp': {
      title: 'Sustainable packaging sample checklist',
      type: 'checklist',
      items: [
        ['Fit', 'Check the actual eyewear fit and safe clearance'],
        ['Package size', 'Avoid unnecessary empty space or an over-tight fit'],
        ['Material reference', 'Confirm the approved material and surface feel'],
        ['Structure', 'Check box strength, pouch usability or foldable-case stability'],
        ['Branding', 'Review logo clarity, balance and color reference'],
        ['Component count', 'Remove layers or pieces that do not serve a clear purpose'],
        ['Claims evidence', 'Keep supporting material information for environmental claims']
      ]
    },
    'geo16v1-hard-soft-foldable-comparison.webp': {
      title: 'Hard, soft and foldable case formats',
      type: 'compare',
      items: [
        ['Hard case', 'Fixed structure', 'Higher crush protection; more storage and carton volume'],
        ['Soft pouch', 'Flexible / packs flat', 'Low bulk; mainly scratch and light-contact protection'],
        ['Foldable case', 'Flat before assembly', 'More structure than a pouch with less empty volume than a fixed case']
      ]
    },
    'geo16v1-artwork-approval.webp': {
      title: 'Artwork and sample approval flow',
      type: 'flow',
      items: [
        ['1', 'Confirm specification', 'Fix cloth size, surface, packaging and project scope'],
        ['2', 'Artwork & placement', 'Confirm print area, orientation, scale and logo position'],
        ['3', 'Proof / sample', 'Approve the visual direction or physical sample'],
        ['4', 'Bulk production', 'Produce only after the approved direction is confirmed']
      ]
    },
    'geo16v1-sample-vs-production.webp': {
      title: 'Sample approval is separate from production MOQ',
      type: 'flow',
      items: [
        ['1', 'Sample approval', 'Review structure, dimensions, appearance, logo and packaging'],
        ['2', 'Confirmed specification', 'Keep the approved sample or approval record with the final quotation'],
        ['3', 'Production order / MOQ', 'Place the bulk order using the confirmed model, material, branding and packaging basis']
      ]
    }
  };

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[char];
    });
  }

  function diagramHtml(config) {
    var items = config.items.map(function (item) {
      if (config.type === 'compare') {
        return '<div class="wika-a014-card wika-a014-card--compare">' +
          '<h4>' + escapeHtml(item[0]) + '</h4>' +
          '<strong>' + escapeHtml(item[1]) + '</strong>' +
          '<p>' + escapeHtml(item[2]) + '</p>' +
        '</div>';
      }
      if (config.type === 'checklist') {
        return '<div class="wika-a014-card wika-a014-card--check">' +
          '<h4>' + escapeHtml(item[0]) + '</h4>' +
          '<p>' + escapeHtml(item[1]) + '</p>' +
        '</div>';
      }
      return '<div class="wika-a014-card wika-a014-card--step">' +
        '<span class="wika-a014-step-no">' + escapeHtml(item[0]) + '</span>' +
        '<h4>' + escapeHtml(item[1]) + '</h4>' +
        '<p>' + escapeHtml(item[2]) + '</p>' +
      '</div>';
    }).join('');
    return '<div class="wika-a014-diagram wika-a014-diagram--' + escapeHtml(config.type) + '" role="group" aria-label="' + escapeHtml(config.title) + '">' +
      '<div class="wika-a014-diagram__heading">' + escapeHtml(config.title) + '</div>' +
      '<div class="wika-a014-diagram__grid">' + items + '</div>' +
    '</div>';
  }

  function enhanceInfographics(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var article = scope.matches && scope.matches('.article-template__content') ? scope : scope.querySelector('.article-template__content');
    if (!article) article = document.querySelector('.article-template__content');
    if (!article) return;

    article.querySelectorAll('img[src*="geo16v1-"]').forEach(function (img) {
      if (img.dataset.wikaA014Done === 'true') return;
      var src = img.getAttribute('src') || '';
      var filename = src.split('/').pop().split('?')[0];
      var replacement = replacements[filename];

      if (replacement) {
        var holder = document.createElement('div');
        holder.innerHTML = diagramHtml(replacement);
        var diagram = holder.firstElementChild;
        img.replaceWith(diagram);
        return;
      }

      var parent = img.parentElement;
      if (parent && parent.classList.contains('wika-a014-media-scroll')) {
        img.dataset.wikaA014Done = 'true';
        return;
      }
      var scroller = document.createElement('div');
      scroller.className = 'wika-a014-media-scroll';
      scroller.setAttribute('role', 'region');
      scroller.setAttribute('aria-label', 'Scrollable infographic');
      var hint = document.createElement('span');
      hint.className = 'wika-a014-media-scroll__hint';
      hint.textContent = 'Swipe horizontally to read the full infographic';
      img.before(scroller);
      scroller.append(hint);
      scroller.append(img);
      img.dataset.wikaA014Done = 'true';
    });
  }

  function init(root) {
    enhanceInfographics(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

/* Keep the desktop/tablet floating entry clear of form content and the footer. */
(function () {
  function setup() {
    var entry = document.querySelector('.wk-whatsapp-float');
    if (!entry) return;
    var queued = false;
    function update() {
      queued = false;
      var rect = entry.getBoundingClientRect();
      var blocked = false;
      if (window.matchMedia('(min-width: 750px)').matches) {
        var areas = document.querySelectorAll('form[action*="/contact"], footer, .menu-drawer[open]');
        for (var i = 0; i < areas.length; i++) {
          var area = areas[i].getBoundingClientRect();
          if (area.width && area.height && area.top < rect.bottom + 16 && area.bottom > rect.top - 16 && area.left < rect.right + 16 && area.right > rect.left - 16) blocked = true;
        }
      }
      entry.style.visibility = blocked ? 'hidden' : '';
    }
    function requestUpdate() { if (!queued) { queued = true; window.requestAnimationFrame(update); } }
    ['scroll', 'resize', 'focusin', 'focusout'].forEach(function (name) { window.addEventListener(name, requestUpdate, { passive: true }); });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true }); else setup();
})();
